import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useConstants } from "../hooks/UseConstants";
import AppSidebarShell from "./layout/AppSidebarShell";

function Sidebar() {
    const { language } = useConstants();
    const { wait } = useContext(AuthContext);
    const isAr = language === 'ar';

    const sections = [
        {
            label: isAr ? 'الرئيسية' : 'Main',
            items: [
                { title: isAr ? 'لوحة التحكم' : 'Dashboard', icon: DashboardOutlinedIcon, link: '/dashboard', end: true },
                { title: isAr ? 'الإشعارات' : 'Notifications', icon: NotificationsNoneOutlinedIcon, link: '/notifications' },
                { title: isAr ? 'الطلاب' : 'Students', icon: SchoolOutlinedIcon, link: '/students' },
                { title: isAr ? 'المالية' : 'Financial', icon: AccountBalanceWalletOutlinedIcon, link: '/financial' },
            ],
        },
        {
            label: isAr ? 'التعليم' : 'Teaching',
            items: [
                { title: isAr ? 'دوراتي' : 'My Courses', icon: CastForEducationOutlinedIcon, link: '/my-courses' },
                { title: isAr ? 'إضافة دورة' : 'Create Course', icon: AddBoxOutlinedIcon, link: '/create-course' },
                { title: isAr ? 'مساراتي' : 'My Paths', icon: AccountTreeOutlinedIcon, link: '/my-paths' },
                { title: isAr ? 'إضافة مسار' : 'Create Path', icon: PlaylistAddOutlinedIcon, link: '/create-path' },
            ],
        },
    ];

    return <AppSidebarShell sections={sections} homeLink="/dashboard" show={!wait} />;
}

export default Sidebar;
